import { type FC } from "react";
import { AppAvatar } from "@/shared/Components";
import { CurvedRectangleIcon } from "@/shared/icons";
import { useUserInfo } from "@/common/AppHeader/model";
import styles from "./styles.module.scss";

export const UserInfo: FC = () => {
  const { profileName } = useUserInfo();

  return (
    <div className={styles["container"]}>
      <div className={styles["user-info-container"]}>
        <AppAvatar name={profileName} image={""} />
        <p className={styles["user-name"]}>{profileName}</p>
      </div>
      <div className={styles["wave-container"]}>
        <CurvedRectangleIcon className={styles.wave} />
      </div>
    </div>
  );
};
